export const M6_MODULE_REVIEW = {
  id: "m6-final-review",
  title: "Module 6 Final Review - The Ultimate Challenge",
  topic: "Master review of everything you've learned! Countries, numbers, times, dates, and contact information. You've got this! 🏆🌍",
  iconType: "trophy",
  
  sets: [
    // ============================================
    // SET 1: COUNTRIES & NATIONALITIES REVIEW
    // ============================================
    {
      id: "m6-final-review-s1",
      title: "Set 1: Countries & Nationalities",
      category: "review",
      exercises: [
        {
          type: "mc",
          q: "I'm from Mexico. I'm ___.",
          options: ["Mexican", "Mexicano", "Mexicana"],
          a: "Mexican",
          tip: "Use English nationality adjective, not Spanish!",
          successtip: "✓ MEXICAN! Nationality adjectives always in English, always capitalized!"
        },
        {
          type: "order",
          q: "Traduce: Ella es brasileña.",
          words: ["She", "is", "Brazilian"],
          a: "She is Brazilian",
          tip: "Brazil → Brazilian! English has no gender in adjectives!",
          successtip: "✓ BRAZILIAN! Same form for masculine and feminine in English!"
        },
        {
          type: "match",
          q: "Match the country to nationality:",
          pairs: [
            { left: "France", right: "French" },
            { left: "Japan", right: "Japanese" },
            { left: "Germany", right: "German" }
          ],
          a: "completed",
          successtip: "✓ PATTERNS! Each country has unique nationality form! France→French, Japan→Japanese!"
        },
        {
          type: "input",
          q: "Complete: I live ___ Toronto. (preposition)",
          a: ["in", "In"],
          tip: "Use IN with cities!",
          successtip: "✓ IN! Cities and countries use IN! IN Toronto, IN Canada, IN Europe!"
        },
        {
          type: "mc",
          q: "Paris is ___ France.",
          options: ["in", "on", "at"],
          a: "in",
          tip: "Cities are IN countries!",
          successtip: "✓ IN! Cities IN countries! Paris IN France, Tokyo IN Japan!"
        },
        {
          type: "order",
          q: "Correct this: I'm from the Mexico.",
          words: ["I'm", "from", "Mexico"],
          a: "I'm from Mexico",
          tip: "No THE before most countries!",
          successtip: "✓ NO THE! Major error for Spanish speakers! Mexico, Canada, France - no article!"
        },
        {
          type: "mc",
          q: "My house is ___ the coast.",
          options: ["in", "on", "at"],
          a: "on",
          tip: "Use ON with coasts!",
          successtip: "✓ ON THE COAST! On the coast, by the sea, near the ocean!"
        },
        {
          type: "input",
          q: "She's from the United Kingdom. She's ___.",
          a: ["British", "british", "English", "english"],
          tip: "UK → British or English (if from England)!",
          successtip: "✓ BRITISH! From UK = British! From England specifically = English!"
        },
        {
          type: "mc",
          q: "The city is ___ the mountains.",
          options: ["in", "on", "at"],
          a: "in",
          tip: "Use IN when surrounded by mountains!",
          successtip: "✓ IN THE MOUNTAINS! Surrounded by = IN! On = beside, In = surrounded!"
        },
        {
          type: "order",
          q: "Traduce: Vivo en la costa este.",
          words: ["I", "live", "on", "the", "east", "coast"],
          a: "I live on the east coast",
          tip: "ON the coast! East coast, west coast, south coast!",
          successtip: "✓ DIRECTIONS! North, south, east, west coast! ON for all coasts!"
        },
        {
          type: "input",
          q: "Complete: He's from Egypt. He's ___.",
          a: ["Egyptian", "egyptian"],
          tip: "Egypt → Egyptian! Pattern: -ian ending!",
          successtip: "✓ EGYPTIAN! Pattern for many countries: Italy→Italian, Brazil→Brazilian!"
        },
        {
          type: "mc",
          q: "ERROR COMÚN: I am a Mexican people. Correct: ___",
          options: ["I am Mexican", "I am a Mexican", "Both are correct"],
          a: "Both are correct",
          tip: "Both work! 'I am Mexican' (adjective) or 'I am a Mexican' (noun)!",
          successtip: "✓ BOTH! I am Mexican (adjective) OR I am a Mexican (noun)! No 'people' needed!"
        }
      ]
    },

    // ============================================
    // SET 2: NUMBERS, TIMES & DATES REVIEW
    // ============================================
    {
      id: "m6-final-review-s2",
      title: "Set 2: Numbers, Times & Dates",
      category: "review",
      exercises: [
        {
          type: "mc",
          q: "How do you say 1/2?",
          options: ["One two", "A half", "One second"],
          a: "A half",
          tip: "Special word! A HALF or ONE HALF!",
          successtip: "✓ A HALF! ½ Most common fraction worldwide!"
        },
        {
          type: "input",
          q: "How do you say 3/4? ___ quarters",
          a: ["three", "Three"],
          tip: "3/4 = THREE QUARTERS! Top number + ordinal plural!",
          successtip: "✓ THREE QUARTERS! 75%! Pattern: top=cardinal, bottom=ordinal!"
        },
        {
          type: "mc",
          q: "How do you say 2.5?",
          options: ["Two point five", "Two comma five", "Two point fifty"],
          a: "Two point five",
          tip: "Use POINT not comma! Each digit separate!",
          successtip: "✓ TWO POINT FIVE! Decimals use POINT! Say each digit after point!"
        },
        {
          type: "order",
          q: "Correct: 3.97 = three point ninety-seven",
          words: ["three", "point", "nine", "seven"],
          a: "three point nine seven",
          tip: "Each digit SEPARATE after point! Not 'ninety-seven'!",
          successtip: "✓ SEPARATE DIGITS! Common error! 3.97 = three point nine seven!"
        },
        {
          type: "mc",
          q: "How do you say 75%?",
          options: ["Seventy-five percentage", "Seventy-five percent", "Seventy-five per hundred"],
          a: "Seventy-five percent",
          tip: "% = PERCENT! Not 'percentage'!",
          successtip: "✓ SEVENTY-FIVE PERCENT! % always 'percent' in numbers!"
        },
        {
          type: "input",
          q: "How do you say 9:30? ___ past ___",
          a: ["half past nine", "Half past nine"],
          tip: "30 minutes = HALF PAST!",
          successtip: "✓ HALF PAST NINE! 9:30! Traditional British way still common!"
        },
        {
          type: "mc",
          q: "How do you say 3:45?",
          options: ["Quarter past four", "Quarter to four", "Half to four"],
          a: "Quarter to four",
          tip: "3:45 = 15 minutes TO 4:00!",
          successtip: "✓ QUARTER TO FOUR! 15 minutes before next hour = quarter to!"
        },
        {
          type: "order",
          q: "Correct ERROR: It's the three o'clock.",
          words: ["It's", "three", "o'clock"],
          a: "It's three o'clock",
          tip: "No THE with time! IT'S three o'clock!",
          successtip: "✓ NO THE! Major Spanish speaker error! No article before time!"
        },
        {
          type: "mc",
          q: "1630 in 24-hour format = ___ in 12-hour.",
          options: ["4:30 AM", "4:30 PM", "6:30 PM"],
          a: "4:30 PM",
          tip: "Subtract 12 from hours over 12! 16-12=4!",
          successtip: "✓ FOUR THIRTY PM! 1630 = 16:30 = 4:30 PM! Military time conversion!"
        },
        {
          type: "input",
          q: "US date format: 03/10/2024 = ___ 10, 2024 (month name)",
          a: ["March", "march"],
          tip: "US puts MONTH first! 03 = March!",
          successtip: "✓ MARCH TENTH! US format month/day/year! Different from most countries!"
        },
        {
          type: "mc",
          q: "UK date format: 10/03/2024 = ___",
          options: ["March 10, 2024", "10 March 2024", "October 3, 2024"],
          a: "10 March 2024",
          tip: "UK puts DAY first! 10/03 = 10th March!",
          successtip: "✓ 10 MARCH! UK format day/month/year! Used in most countries!"
        },
        {
          type: "order",
          q: "Say in UK format: 5 de enero de 2025",
          words: ["the", "fifth", "of", "January", "two", "thousand", "twenty-five"],
          a: "the fifth of January two thousand twenty-five",
          tip: "UK: THE fifth OF January! Use 'the' and 'of'!",
          successtip: "✓ UK FORMAL! 'The fifth of January'! US would say 'January fifth'!"
        }
      ]
    },

    // ============================================
    // SET 3: CONTACT INFORMATION REVIEW
    // ============================================
    {
      id: "m6-final-review-s3",
      title: "Set 3: Contact Information",
      category: "review",
      exercises: [
        {
          type: "mc",
          q: "How do you say @ in email addresses?",
          options: ["Arroba", "At", "A"],
          a: "At",
          tip: "@ = AT in English! Not Spanish 'arroba'!",
          successtip: "✓ AT! Universal! name@email.com = name AT email DOT com!"
        },
        {
          type: "input",
          q: "How do you say . (period) in emails? (one word)",
          a: ["dot", "Dot"],
          tip: "Period = DOT in emails/websites!",
          successtip: "✓ DOT! . = DOT! maria.smith@email.com = maria DOT smith AT email DOT com!"
        },
        {
          type: "order",
          q: "Correct ERROR: maria arroba gmail punto com",
          words: ["maria", "at", "gmail", "dot", "com"],
          a: "maria at gmail dot com",
          tip: "Use English words! AT and DOT!",
          successtip: "✓ ENGLISH! maria@gmail.com = maria AT gmail DOT com! International standard!"
        },
        {
          type: "mc",
          q: "How do you say 555?",
          options: ["Five five five", "Triple five", "Both are correct"],
          a: "Both are correct",
          tip: "Can say individually OR use 'triple'!",
          successtip: "✓ BOTH! Five five five OR triple five! Personal preference!"
        },
        {
          type: "mc",
          q: "How do you say 44 in phone numbers?",
          options: ["Forty-four", "Double four", "Both are correct"],
          a: "Both are correct",
          tip: "Can say 'forty-four' OR 'double four'!",
          successtip: "✓ BOTH! Forty-four OR double four! Double is faster!"
        },
        {
          type: "input",
          q: "US: cell phone. UK: ___ (phone type)",
          a: ["mobile", "Mobile", "mobile phone", "Mobile phone"],
          tip: "UK says MOBILE not cell phone!",
          successtip: "✓ MOBILE! US/UK difference! Cell phone vs mobile phone!"
        },
        {
          type: "match",
          q: "Match US term to UK term:",
          pairs: [
            { left: "Zip code", right: "Postcode" },
            { left: "Cell phone", right: "Mobile" },
            { left: "Apartment", right: "Flat" }
          ],
          a: "completed",
          successtip: "✓ US vs UK! Different words, same meaning! Know both for international use!"
        },
        {
          type: "mc",
          q: "How do you say www?",
          options: ["World wide web", "Double-u double-u double-u", "W W W"],
          a: "Double-u double-u double-u",
          tip: "Say letter W three times! 'Double-u' three times!",
          successtip: "✓ DOUBLE-U! WWW = double-u double-u double-u! Often skipped now!"
        },
        {
          type: "order",
          q: "Say website: www.company.com",
          words: ["double-u", "double-u", "double-u", "dot", "company", "dot", "com"],
          a: "double-u double-u double-u dot company dot com",
          tip: "Three double-u, DOT company DOT com!",
          successtip: "✓ WEBSITE! Pattern: www DOT name DOT extension! .com most common!"
        },
        {
          type: "input",
          q: "When someone asks 'How do you spell that?', you say each ___.",
          a: ["letter", "Letter"],
          tip: "SPELL = say each LETTER! M-A-R-I-A!",
          successtip: "✓ LETTER! Spelling = saying alphabet letters one by one!"
        },
        {
          type: "mc",
          q: "ERROR COMÚN: My name is the Maria. Correct: ___",
          options: ["My name is Maria", "My name is a Maria", "My names is Maria"],
          a: "My name is Maria",
          tip: "No THE before names! My name IS Maria!",
          successtip: "✓ NO THE! Never use THE before personal names in English!"
        },
        {
          type: "order",
          q: "Traduce: ¿Cuál es tu correo electrónico?",
          words: ["What's", "your", "email", "address"],
          a: "What's your email address",
          tip: "EMAIL ADDRESS! Essential question!",
          successtip: "✓ EMAIL ADDRESS! With name and phone = complete contact info!"
        }
      ]
    },

    // ============================================
    // SET 4: COMMON ERRORS - ULTIMATE CORRECTION
    // ============================================
    {
      id: "m6-final-review-s4",
      title: "Set 4: Common Errors Challenge",
      category: "review",
      exercises: [
        {
          type: "order",
          q: "CORRECT: I'm from the United States.",
          words: ["I'm", "from", "the", "United", "States"],
          a: "I'm from the United States",
          tip: "THE United States is an EXCEPTION! Needs THE!",
          successtip: "✓ EXCEPTION! THE United States, THE United Kingdom, THE Philippines need THE!"
        },
        {
          type: "mc",
          q: "ERROR: Son las tres. English: ___",
          options: ["They are three", "It's three o'clock", "Are three o'clock"],
          a: "It's three o'clock",
          tip: "Use IT'S for time, not 'they are'!",
          successtip: "✓ IT'S! Always IT'S for time! Not 'they are' like Spanish 'son las'!"
        },
        {
          type: "order",
          q: "CORRECT: I live in the 123 Main Street.",
          words: ["I", "live", "at", "123", "Main", "Street"],
          a: "I live at 123 Main Street",
          tip: "No THE! Use AT for addresses!",
          successtip: "✓ TWO ERRORS! No THE, and use AT not IN! AT 123 Main Street!"
        },
        {
          type: "mc",
          q: "ERROR: My email is maria arroba gmail punto com. Fix: ___",
          options: ["maria at gmail dot com", "maria a gmail point com", "maria arroba gmail dot com"],
          a: "maria at gmail dot com",
          tip: "AT and DOT in English!",
          successtip: "✓ ENGLISH TERMS! @ = AT, . = DOT! Essential for international communication!"
        },
        {
          type: "input",
          q: "ERROR: The five and half hours. CORRECT: ___ and a ___ hours",
          a: ["five, half", "Five, half", "five and a half", "Five and a half"],
          tip: "No THE! FIVE and A half!",
          successtip: "✓ TWO ERRORS! No THE before numbers, and use A before half!"
        },
        {
          type: "mc",
          q: "ERROR: I'm Mexican people. Fix: ___",
          options: ["I'm Mexican", "I'm a Mexican", "Both A and B"],
          a: "Both A and B",
          tip: "Both work! 'Mexican' alone OR 'a Mexican'!",
          successtip: "✓ BOTH! Mexican is already complete! No 'people' needed!"
        },
        {
          type: "order",
          q: "CORRECT: Three point ninety-seven",
          words: ["three", "point", "nine", "seven"],
          a: "three point nine seven",
          tip: "Each digit SEPARATE after point!",
          successtip: "✓ SEPARATE! 3.97 = three point NINE SEVEN, not ninety-seven!"
        },
        {
          type: "mc",
          q: "ERROR: I live in coast. Fix: ___",
          options: ["I live in the coast", "I live on the coast", "I live at coast"],
          a: "I live on the coast",
          tip: "ON the coast! Need article THE!",
          successtip: "✓ TWO CHANGES! ON (not in) and THE (article needed)! ON the coast!"
        },
        {
          type: "input",
          q: "ERROR: At the 1630 hours. CORRECT: At ___ (no 'the', no 'hours')",
          a: ["1630", "sixteen thirty"],
          tip: "No THE! No 'hours'! Just 'at 1630'!",
          successtip: "✓ SIMPLE! At 1630! No extra words! Military/transport time!"
        },
        {
          type: "match",
          q: "Match ERROR to CORRECTION:",
          pairs: [
            { left: "I'm from the Mexico", right: "I'm from Mexico" },
            { left: "The three o'clock", right: "Three o'clock" },
            { left: "In the coast", right: "On the coast" }
          ],
          a: "completed",
          successtip: "✓ MAJOR ERRORS! These are the most common mistakes for Spanish speakers!"
        },
        {
          type: "mc",
          q: "ERROR: 03/10/2024 in US = October 3rd. True or False?",
          options: ["True", "False - it's March 10th", "False - it's January 3rd"],
          a: "False - it's March 10th",
          tip: "US format: MONTH/DAY! 03 = March!",
          successtip: "✓ FALSE! US = month first! 03/10 = March 10, not October 3!"
        },
        {
          type: "order",
          q: "FINAL ERROR CHECK: The my name is the Maria.",
          words: ["My", "name", "is", "Maria"],
          a: "My name is Maria",
          tip: "Remove BOTH 'the'! No THE before possessives or names!",
          successtip: "✓ NO THE! Never before 'my/your/his' and never before names!"
        }
      ]
    },

    // ============================================
    // SET 5: ULTIMATE INTEGRATION & CELEBRATION
    // ============================================
    {
      id: "m6-final-review-s5",
      title: "Set 5: Ultimate Challenge - Boss Battle! 🏆",
      category: "review",
      exercises: [
        {
          type: "order",
          q: "BOSS Q1: Complete intro: Hi, I'm Ana, I'm from Chile, and I live in Santiago.",
          words: ["Hi", "I'm", "Ana", "I'm", "from", "Chile", "and", "I", "live", "in", "Santiago"],
          a: "Hi I'm Ana I'm from Chile and I live in Santiago",
          tip: "Name + origin + location! Complete introduction!",
          successtip: "✓ INTRODUCTION! Perfect! Name, country, and city! Professional standard!"
        },
        {
          type: "mc",
          q: "BOSS Q2: Ana is Chilean. Santiago is in the center of Chile. She lives ___ the coast?",
          options: ["Yes, on the coast", "No, in the center", "Yes, by the sea"],
          a: "No, in the center",
          tip: "Santiago is IN the center, not on the coast!",
          successtip: "✓ READING COMPREHENSION! Santiago = center, not coast! Pay attention!"
        },
        {
          type: "input",
          q: "BOSS Q3: Ana says: 'Contact me at a.garcia@company.cl' - How to say @?",
          a: ["at", "At"],
          tip: "@ = AT! International standard!",
          successtip: "✓ AT! You mastered email pronunciation! a DOT garcia AT company DOT cl!"
        },
        {
          type: "mc",
          q: "BOSS Q4: Ana's meeting is at 3:45 PM. Another way to say this?",
          options: ["Quarter past three", "Quarter to four", "Half past three"],
          a: "Quarter to four",
          tip: "3:45 = 15 minutes TO 4:00!",
          successtip: "✓ QUARTER TO FOUR! You mastered traditional time expressions!"
        },
        {
          type: "order",
          q: "BOSS Q5: Ana joined on 08/15/2024 (US format). Say it: ___ ___, ___",
          words: ["August", "fifteenth", "two", "thousand", "twenty-four"],
          a: "August fifteenth two thousand twenty-four",
          tip: "US format: month + ordinal day + year!",
          successtip: "✓ US DATE! August fifteenth! You understand both US and UK formats!"
        },
        {
          type: "mc",
          q: "BOSS Q6: Ana says '75% of my team speaks Spanish.' What fraction is 75%?",
          options: ["Two thirds", "Three quarters", "Four fifths"],
          a: "Three quarters",
          tip: "75% = 3/4 = THREE QUARTERS!",
          successtip: "✓ THREE QUARTERS! You can convert between percentages and fractions!"
        },
        {
          type: "input",
          q: "BOSS Q7: Ana's office temperature is 22.5°C. How to say the decimal? twenty-two ___ ___",
          a: ["point five", "Point five", "point Five"],
          tip: "POINT five! Each digit separate!",
          successtip: "✓ POINT FIVE! You mastered decimal pronunciation!"
        },
        {
          type: "match",
          q: "BOSS Q8: Match Ana's info to correct format:",
          pairs: [
            { left: "Email", right: "a.garcia@company.cl" },
            { left: "Time", right: "3:45 PM" },
            { left: "Date", right: "August 15, 2024" }
          ],
          a: "completed",
          successtip: "✓ FORMATS! You recognize all contact information formats!"
        },
        {
          type: "mc",
          q: "BOSS Q9: Ana has worked in 3 countries: Chile, Peru, and Colombia. Which continent?",
          options: ["All North America", "All South America", "Mix of continents"],
          a: "All South America",
          tip: "Chile, Peru, Colombia all in South America!",
          successtip: "✓ GEOGRAPHY! You know country locations and continents!"
        },
        {
          type: "order",
          q: "BOSS Q10: Ana's phone: +56 2 2555 0987. Say area code with 'double': two, ___ five, oh-nine-eight-seven",
          words: ["double", "five"],
          a: "double five",
          tip: "55 = DOUBLE FIVE! Faster pronunciation!",
          successtip: "✓ DOUBLE! You can say phone numbers naturally like native speakers!"
        },
        {
          type: "input",
          q: "BOSS Q11: Ana says she's 'from Chile' but 'lives in Santiago.' From = origin, Lives ___ = current location (preposition)",
          a: ["in", "In"],
          tip: "FROM = origin, LIVE IN = current location!",
          successtip: "✓ PREPOSITIONS! FROM (origin) vs IN (location)! You understand the difference!"
        },
        {
          type: "order",
          q: "🏆 FINAL BOSS! Say it with pride: I completed Module 6 successfully!",
          words: ["I", "completed", "Module", "6", "successfully"],
          a: "I completed Module 6 successfully",
          tip: "You've mastered countries, numbers, times, dates, and contact information!",
          successtip: "🎉🎊🏆 ¡VICTORIA ÉPICA! ¡MODULE 6 CONQUERED! 🏆🎊🎉\n\nYou are now a MODULE 6 MASTER! You can:\n✅ Talk about countries, nationalities, and locations\n✅ Use prepositions correctly (in, on, at, by)\n✅ Say fractions, decimals, and percentages\n✅ Tell time in multiple formats (12h/24h)\n✅ Understand and say dates (US and UK formats)\n✅ Give complete contact information\n✅ Spell names and pronounce emails/websites\n✅ Avoid common Spanish speaker errors\n\nYou've completed 180 exercises across 3 units + 120 reading + 60 review = 360 TOTAL EXERCISES! 🚀\n\nYou can now communicate confidently about locations, statistics, schedules, and personal information in English anywhere in the world! 🌍\n\n¡FELICITACIONES! You're ready for advanced modules! Keep going! 💪✨"
        }
      ]
    }
  ]
};
